import {copilot} from '@cl/shared';
import accountAnalyticsAgent from 'common/src/modules/analytics/copilot/agents/accountAnalyticsAgent/accountAnalyticsAgent';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import accountAnalyticsSkill from 'common/src/modules/analytics/copilot/skills/accountAnalyticsSkill';
import {CLStore} from 'common/src/redux/store';

function initializeAnalyticsAgents(store: CLStore) {
  if (!isFlagEnabled(FeatureFlagKey.EnableCopilotSkills)) {
    copilot.registerAgent(accountAnalyticsAgent(store));
  }

  copilot.skills.registerSkill(accountAnalyticsSkill(store));
}

export default initializeAnalyticsAgents;
